//@ts-ignore
export const getWindowEnv = () => (typeof window !== "undefined" && window.__ENV) || undefined;
